import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PortalTranslationService } from '../../core/services/portal-translation.service';

interface PortalNavItem {
  path: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'investigator-side-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, ButtonModule],
  templateUrl: './investigator-side-nav.component.html',
  styleUrl: './investigator-side-nav.component.scss',
})
export class InvestigatorSideNavComponent {
  readonly translation = inject(PortalTranslationService);
  readonly collapsed = signal(false);
  readonly items: PortalNavItem[] = [
    { path: '/queue', label: 'menuCaseQueue', icon: 'pi pi-list' },
    { path: '/reports', label: 'reports', icon: 'pi pi-chart-bar' },
    // { path: '/settings', label: 'settings', icon: 'pi pi-cog' },
  ];

  translatedLabel(item: PortalNavItem): string {
    return this.translation.translate(item.label as 'menuCaseQueue' | 'reports' | 'settings');
  }

  toggleCollapsed(): void {
    this.collapsed.update((value) => !value);
  }
}
